module.exports = __webpack_public_path__ + "img/icon-caution.b725fbe9.svg";